import type { AddressFieldValue } from '../hooks/useAddressField';
import type { Province } from '../models/AddressModel';

/** Address object with all fields normalized to strings (form snapshots / API payloads). */
export type NormalizedAddressValue = {
  address_line: string;
  province: string;
  ward: string;
  free_address: string;
};

const EMPTY_ADDRESS: NormalizedAddressValue = {
  address_line: '',
  province: '',
  ward: '',
  free_address: '',
};

const resolveRelationId = (value: unknown): string => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'object' && 'id' in value) {
    return String((value as { id: string }).id ?? '');
  }
  return String(value);
};

export function normalizeAddressFieldValue(address?: unknown): NormalizedAddressValue {
  if (!address || typeof address !== 'object') {
    return { ...EMPTY_ADDRESS };
  }

  const record = address as Record<string, unknown>;

  return {
    address_line: String(record.address_line ?? ''),
    province: resolveRelationId(record.province),
    ward: resolveRelationId(record.ward),
    free_address: String(record.free_address ?? ''),
  };
}

export function findHoChiMinhProvinceId(provinces: Province[]): string | undefined {
  const match = provinces.find(
    (province) =>
      province.name === 'Thành phố Hồ Chí Minh' ||
      province.name === 'TP.HCM' ||
      province.short_name === 'HCM'
  );
  return match?.id;
}

export function withDefaultHoChiMinhProvince(
  address: AddressFieldValue,
  provinces: Province[]
): AddressFieldValue {
  if (address.province) {
    return address;
  }

  const provinceId = findHoChiMinhProvinceId(provinces);
  if (!provinceId) {
    return address;
  }

  return {
    ...address,
    province: provinceId,
  };
}
